module.exports = __webpack_public_path__ + "img/2-2.e8d2cfe4.svg";